// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/64b1908e/" + chunkId + "." + __webpack_require__.h() + ".v64b1908e.js";
};